import { Navigate, Outlet, RouterProvider, createBrowserRouter } from "react-router";
import { AuthProvider, useAuth } from "./auth.js";
import { Layout } from "./components/Layout.js";
import { Loading } from "./components/ui.js";
import { AuditPage, RunnersPage, SettingsPage } from "./pages/Admin.js";
import { Dashboard, Projects } from "./pages/Dashboard.js";
import { DevicePage } from "./pages/Device.js";
import { Home, SignIn } from "./pages/Home.js";
import { DeploymentPage, JobPage, PipelinePage } from "./pages/Pipeline.js";
import { ProjectPage } from "./pages/Project.js";
import { Resolve } from "./pages/Resolve.js";

function RequireAuth() {
  const auth = useAuth();
  if (!auth.ready) return <Loading label="Signing in…" />;
  if (!auth.user) return <SignIn />;
  return <Outlet />;
}

export const routes = [
  { path: "/device", element: <DevicePage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/pipelines/:id", element: <Resolve kind="pipelines" /> },
      { path: "/deployments/:id", element: <Resolve kind="deployments" /> },
      { path: "/projects/:id", element: <Resolve kind="projects" /> },
      {
        path: "/o/:org",
        element: <Layout />,
        children: [
          { index: true, element: <Dashboard /> },
          { path: "projects", element: <Projects /> },
          { path: "projects/:project", element: <ProjectPage /> },
          { path: "projects/:project/:tab", element: <ProjectPage /> },
          { path: "pipelines/:id", element: <PipelinePage /> },
          { path: "jobs/:id", element: <JobPage /> },
          { path: "deployments/:id", element: <DeploymentPage /> },
          { path: "runners", element: <RunnersPage /> },
          { path: "audit", element: <AuditPage /> },
          { path: "settings", element: <SettingsPage /> },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
];

const router = createBrowserRouter(routes);

export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
